/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modals/Modal';

import useTimerHandler from 'pages/machinery/hooks/useTimerHandler';
import MachineInformationSide from './counterOfferModalPartials/MachineInformationSide';
import OfferSide from './counterOfferModalPartials/OfferSide';

const CounterOfferModal = ({
  visible, setVisible, counterOfferData, machine, setHowToAuctionWorkModalVisible, setCounterOfferData, setCounterOfferPlacedResponse, counterOfferPlacedResponse,
}) => {
  const { timeLeft } = useTimerHandler({ machine });

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-content modal-transparent">
        <div className="modal-body p-0">
          <div className="row">
            <MachineInformationSide
              machine={machine}
              timeLeft={timeLeft}
            />
            <OfferSide
              setVisible={setVisible}
              counterOfferData={counterOfferData}
              setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
              setCounterOfferData={setCounterOfferData}
              setCounterOfferPlacedResponse={setCounterOfferPlacedResponse}
              counterOfferPlacedResponse={counterOfferPlacedResponse}
            />
          </div>
          <div className="row mt-4 mb-4">
            <div className="col">
              <div className="separator separator--horizontal" />
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <i className="fa-solid fa-info-circle text-white fs-22" />
            </div>
            <div className="col">
              <div className="text-white fs-12 fw-700">
                <p>
                  Verilen teklifler, teklif verenin sorumluluğundadır ve bağlayıcıdır. Verilen teklifi geri almak veya caymak mümkün değildir.
                </p>
                <p>
                  Teklifiniz, açık artırmayı kazanan teklif olduğu takdirde makinayı satın almayı kabul etmiş olursunuz. Açık artırmasını kazandığınız iş makinasını satın almaktan vazgeçerseniz teminat bedeli iade alma hakkını kaybedersiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

CounterOfferModal.propTypes = {
  visible: PropTypes.object,
  setVisible: PropTypes.func,
  machine: PropTypes.object,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  counterOfferData: PropTypes.object,
  setCounterOfferData: PropTypes.object,
  setCounterOfferPlacedResponse: PropTypes.func,
  counterOfferPlacedResponse: PropTypes.object,

};

export default memo(CounterOfferModal);
